import * as React from 'react'

import { observer } from 'mobx-react'

import BaseCompactPopup from '~/client/src/shared/components/BaseCompactPopup/BaseCompactPopup'
import { Button } from '~/client/src/shared/components/shadcn-ui/button'

import SitePermitCreationFormStore from '../../WorkflowCreationForm.store'
import PermitFormFieldWrapper from '../PermitFormFieldWrapper'

import './InspectionPopupForm.scss'

interface IProps {
  store: SitePermitCreationFormStore

  isReadOnly?: boolean
}

const notInUse = 'Not in use'
const useLog = 'Use log'
const inspection = 'Inspection'
const inspectionHasNoFields = (isEmissionType: boolean) =>
  `${isEmissionType ? 'Use log' : 'Inspection'} has no fields`
const submit = 'Submit'
const submitInspection = 'Submit inspection'
const _updateInspection = 'Update inspection'

@observer
export default class InspectionPopupForm extends React.Component<IProps> {
  public render() {
    const { store, isReadOnly } = this.props
    const {
      inspectionFieldsStore,
      isInspectionEditAllowedForUser,
      isBeforeDeadlineEnds,
      template,
      shouldShowInspectionPopup,
    } = store
    const { deselectInspection, availableWorkflowSteps } = inspectionFieldsStore

    const isInspectionReadOnly =
      isReadOnly ||
      !isBeforeDeadlineEnds ||
      !isInspectionEditAllowedForUser ||
      !template?.isInspectionType

    return (
      <BaseCompactPopup
        isShown={shouldShowInspectionPopup}
        title={template?.isEmissionFormType ? useLog : inspection}
        containerClassName="inspection-popup-form"
        childrenClassName="col overflow-hidden"
        titleClassName="text center small-header bold two-line-text-ellipsis"
        onHide={deselectInspection}
      >
        {shouldShowInspectionPopup && (
          <>
            <div className="permit-form-fields tw:h-full tw:flex tw:flex-col tw:overflow-y-auto">
              <div className="tw:flex tw:flex-col fields-section tw:px-4 tw:py-2.5">
                {!availableWorkflowSteps.length && (
                  <span className="tw:text-title-md tw:text-primary tw:flex tw:items-center tw:justify-center tw:py-5">
                    {inspectionHasNoFields(template?.isEmissionFormType)}
                  </span>
                )}
              </div>
              {availableWorkflowSteps.map(step => (
                <div key={step.id} className="tw:flex tw:flex-col tw:py-2.5">
                  <div className="tw:flex tw:flex-col fields-section tw:px-4">
                    {step.fields.map(typeField => (
                      <PermitFormFieldWrapper
                        key={typeField.id}
                        typeField={typeField}
                        store={store}
                        fieldsStore={inspectionFieldsStore}
                        isViewMode={isInspectionReadOnly}
                      />
                    ))}
                  </div>
                </div>
              ))}
            </div>
            {!isInspectionReadOnly && this.actionButtons}
          </>
        )}
      </BaseCompactPopup>
    )
  }

  private get actionButtons(): JSX.Element {
    const {
      editablePermit,
      inspectionFieldsStore,
      isBeforeDeadlineEnds,
      isInspectionEditAllowedForUser,
      isEmissionFormType,
      addInspection,
      updateInspection,
      addNotInUseInspection,
    } = this.props.store
    const {
      editableEntity,
      isNewInspection,
      areAllFieldsValid,
      areRequiredFieldsChanged,
      areOptionalFieldsChanged,
    } = inspectionFieldsStore

    if (
      !isBeforeDeadlineEnds ||
      !editableEntity ||
      !editablePermit ||
      editablePermit.isDoneOrDenied
    ) {
      return null
    }

    if (isNewInspection) {
      return (
        <div className="tw:flex tw:items-center tw:justify-center tw:bg-background tw:border-0 tw:border-t tw:border-solid tw:border-border tw:p-5">
          <Button
            variant="outline"
            className="tw:flex-1 tw:mr-2.5 tw:grow tw:overflow-hidden tw:whitespace-nowrap tw:text-ellipsis"
            onClick={addNotInUseInspection}
          >
            {notInUse}
          </Button>
          <Button
            variant="primary-outline"
            disabled={!areAllFieldsValid}
            className="tw:flex-1 tw:grow tw:overflow-hidden tw:whitespace-nowrap tw:text-ellipsis"
            onClick={addInspection}
          >
            {isEmissionFormType ? submit : submitInspection}
          </Button>
        </div>
      )
    }

    if (isInspectionEditAllowedForUser) {
      return (
        <div className="tw:flex tw:items-center tw:bg-background tw:border-0 tw:border-t tw:border-solid tw:border-border tw:p-5">
          <Button
            variant="default"
            disabled={
              !(
                (areRequiredFieldsChanged || areOptionalFieldsChanged) &&
                areAllFieldsValid
              )
            }
            className="tw:flex-1 tw:grow tw:overflow-hidden tw:whitespace-nowrap tw:text-ellipsis"
            onClick={updateInspection}
          >
            {_updateInspection}
          </Button>
        </div>
      )
    }

    return null
  }
}
